module.exports = __webpack_public_path__ + "img/postepay.2c7703b7.svg";